import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export default function PaymentAlert() {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.background.red.light,
        borderRadius: 3,
        padding: theme.spacing(2, 3),
      })}
    >
      <Stack gap={0.5}>
        <Text size="sm" weight="bold" color="red">
          <FormattedMessage id="dashboard.paymentReturn.alert.title" />
        </Text>
        <Text size="sm" color="red">
          <FormattedMessage id="dashboard.paymentReturn.alert.message" />
        </Text>
      </Stack>
    </Box>
  );
}
